<template>
  <select @change="({ target: { value } }) => value === '' ? reset() : setItem(value)">
    <slot />
  </select>
</template>

<script>
import { inject } from '@vue/composition-api'

export default {
  setup() {
    const { setItem, reset } = inject(Symbol.for('filter'))

    return {
      reset,
      setItem,
    }
  },
}
</script>
